import type { Feature, FeatureCollection, MultiPolygon, Polygon } from "geojson";
import type { Coordinates, SpotId } from "./types";

export type DefaultStartFacility = {
  spotId: SpotId;
  label: string;
  coordinates: Coordinates;
  geometry: Polygon | MultiPolygon;
  geometryAccuracy: "osm" | "approximate";
  sourceUrl: string;
};

const defaultStartFacilities: Record<SpotId, DefaultStartFacility> = {
  ariake: {
    spotId: "ariake",
    label: "東京ビッグサイト",
    coordinates: { latitude: 35.633601, longitude: 139.798662 },
    geometryAccuracy: "osm",
    sourceUrl: "https://www.openstreetmap.org/relation/7743566",
    geometry: {
      type: "MultiPolygon",
      coordinates: [
        [
          [
            [139.7958165, 35.6257691],
            [139.7969136, 35.6263588],
            [139.7955255, 35.628031],
            [139.7966869, 35.6286556],
            [139.7966896, 35.628672],
            [139.7957361, 35.6298547],
            [139.7956261, 35.6300738],
            [139.7955859, 35.6301937],
            [139.7955617, 35.6303049],
            [139.7955215, 35.6306101],
            [139.7955161, 35.630972],
            [139.7955148, 35.631287],
            [139.7954826, 35.6314331],
            [139.7954166, 35.6315815],
            [139.7952989, 35.6317753],
            [139.7951446, 35.6319563],
            [139.7950143, 35.6319789],
            [139.7922412, 35.6304847],
            [139.7922932, 35.630422],
            [139.7922224, 35.630385],
            [139.7925375, 35.629979],
            [139.7929144, 35.6295331],
            [139.7930016, 35.6294078],
            [139.7931249, 35.629144],
            [139.7937358, 35.6284068],
            [139.7938696, 35.6281857],
            [139.7955263, 35.6261413],
            [139.7958165, 35.6257691],
          ],
        ],
        [
          [
            [139.7967312, 35.6294743],
            [139.7968505, 35.6293326],
            [139.7997044, 35.6308739],
            [139.7998948, 35.6309611],
            [139.80004, 35.6310049],
            [139.8000268, 35.6313422],
            [139.799898, 35.6346358],
            [139.798708, 35.6339651],
            [139.7955751, 35.6322767],
            [139.7955282, 35.632159],
            [139.7956932, 35.6319476],
            [139.7957924, 35.6318146],
            [139.7959158, 35.6315682],
            [139.7959614, 35.6313731],
            [139.7959882, 35.6308455],
            [139.7959922, 35.6304956],
            [139.7960244, 35.6303092],
            [139.7960834, 35.6301414],
            [139.7961625, 35.6300073],
            [139.7965702, 35.6295026],
            [139.7967312, 35.6294743],
          ],
        ],
      ],
    },
  },
  "tokyo-dome": {
    spotId: "tokyo-dome",
    label: "東京ドーム",
    coordinates: { latitude: 35.7056, longitude: 139.7519 },
    geometryAccuracy: "osm",
    sourceUrl: "https://www.openstreetmap.org/way/20028328",
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [139.7513598, 35.7064612],
          [139.7515235, 35.7064901],
          [139.7517468, 35.7064952],
          [139.7521794, 35.7064623],
          [139.7523926, 35.7064262],
          [139.7525588, 35.7063778],
          [139.7526593, 35.7063386],
          [139.7527745, 35.706248],
          [139.7528709, 35.7061439],
          [139.7529162, 35.7061581],
          [139.7530749, 35.7060648],
          [139.753143, 35.7058579],
          [139.7531508, 35.705673],
          [139.7531475, 35.7054376],
          [139.7531262, 35.705252],
          [139.7530789, 35.7050554],
          [139.7529928, 35.7048943],
          [139.7528655, 35.7047525],
          [139.7526958, 35.7046419],
          [139.7525916, 35.7045943],
          [139.7524667, 35.7045587],
          [139.7523944, 35.7045434],
          [139.7523461, 35.7045366],
          [139.7522891, 35.704533],
          [139.7522608, 35.7045617],
          [139.7521553, 35.7045742],
          [139.7518103, 35.7046149],
          [139.7515323, 35.7046478],
          [139.7514454, 35.70461],
          [139.7513718, 35.7046016],
          [139.7512855, 35.7046646],
          [139.7510745, 35.7047411],
          [139.7509984, 35.7048903],
          [139.7510216, 35.7049229],
          [139.7509335, 35.7050014],
          [139.750846, 35.7051343],
          [139.7508066, 35.7052455],
          [139.7507985, 35.7052842],
          [139.7507889, 35.70533],
          [139.75078, 35.7054681],
          [139.7508092, 35.7057256],
          [139.7508613, 35.705993],
          [139.750925, 35.7061552],
          [139.7509995, 35.70625],
          [139.7511073, 35.7063438],
          [139.751219, 35.7064118],
          [139.7513598, 35.7064612],
        ],
      ],
    },
  },
  "shibuya-station": {
    spotId: "shibuya-station",
    label: "渋谷駅",
    coordinates: { latitude: 35.658, longitude: 139.7016 },
    geometryAccuracy: "approximate",
    sourceUrl: "https://www.openstreetmap.org/search?query=渋谷駅",
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [139.70055, 35.65695],
          [139.70135, 35.65665],
          [139.70215, 35.6572],
          [139.703, 35.65825],
          [139.70285, 35.6591],
          [139.70195, 35.65945],
          [139.7008, 35.6591],
          [139.70035, 35.6581],
          [139.70055, 35.65695],
        ],
      ],
    },
  },
  "ikebukuro-station": {
    spotId: "ikebukuro-station",
    label: "池袋駅",
    coordinates: { latitude: 35.7295, longitude: 139.7109 },
    geometryAccuracy: "approximate",
    sourceUrl: "https://www.openstreetmap.org/search?query=池袋駅",
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [139.7087, 35.7281],
          [139.7102, 35.7279],
          [139.712, 35.7284],
          [139.7123, 35.7305],
          [139.7113, 35.7313],
          [139.7092, 35.7311],
          [139.70845, 35.7302],
          [139.7087, 35.7281],
        ],
      ],
    },
  },
};

export const getDefaultStartFacility = (spotId: SpotId) =>
  defaultStartFacilities[spotId];

export const defaultStartFacilityCollection = (
  facility: DefaultStartFacility,
): FeatureCollection<Polygon | MultiPolygon> => ({
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      id: `default-start-${facility.spotId}`,
      geometry: facility.geometry,
      properties: {
        spotId: facility.spotId,
        label: facility.label,
        geometryAccuracy: facility.geometryAccuracy,
      },
    } satisfies Feature<Polygon | MultiPolygon>,
  ],
});
